var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 56,
    fill: "#FCE1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3197 106.599L55.4745 97.7536C52.9731 95.2547 51.5694 91.8629 51.5733 88.3272V72.7462C51.5725 69.2146 52.9761 65.8277 55.4745 63.3317L64.3197 54.4805C66.8165 51.9752 70.2092 50.569 73.7462 50.5733H89.3272C92.8587 50.5726 96.2457 51.9761 98.7417 54.4745L107.593 63.3257C110.096 65.8214 111.502 69.2114 111.5 72.7462V88.3272C111.501 91.8587 110.097 95.2457 107.599 97.7417L98.7477 106.593C96.2527 109.097 92.8622 110.503 89.3272 110.5H73.7462C70.2104 110.504 66.8186 109.1 64.3197 106.599Z",
    fill: "#373737",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2464 103.526L52.4013 94.6804C49.8999 92.1815 48.4961 88.7896 48.5 85.2539V69.6729C48.4993 66.1414 49.9028 62.7544 52.4013 60.2584L61.2464 51.4072C63.7432 48.902 67.1359 47.4957 70.6729 47.5H86.2539C89.7855 47.4993 93.1724 48.9028 95.6684 51.4013L104.52 60.2524C107.023 62.7481 108.429 66.1382 108.427 69.6729V85.2539C108.428 88.7855 107.024 92.1724 104.526 94.6684L95.6744 103.52C93.1795 106.024 89.789 107.43 86.2539 107.427H70.6729C67.1372 107.431 63.7454 106.027 61.2464 103.526Z",
    fill: "#C91B45",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6206 79.4875V61.6072C74.6206 59.7556 76.3405 58.2546 78.4621 58.2546C80.5837 58.2546 82.3035 59.7556 82.3035 61.6072V79.4875C82.3035 81.339 80.5837 82.84 78.4621 82.84C76.3405 82.84 74.6206 81.339 74.6206 79.4875Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4621 87.4497C80.5832 87.4497 82.3035 89.17 82.3035 91.2912C82.3035 93.4123 80.5832 95.1326 78.4621 95.1326C76.3409 95.1326 74.6206 93.4123 74.6206 91.2912C74.6206 89.17 76.3409 87.4497 78.4621 87.4497Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic-error.9b2deb328c97fb3a2e5bb4e3936a5793.svg";
export { ForwardRef as ReactComponent };